module.exports = __webpack_public_path__ + "img/3.d98f4e73.png";